import { AModel } from '../../../../api/abstracts/model.abstract';
import { BuyProgramModel } from './buy-program.model';

export class UpdateOfferModel extends AModel {
    public fillables: any = {
        dealId: 'DealId',
        ecsType: 'EcsType',
        sessionId: 'SessionId',
        inquiryId: 'InquiryId',
        approvalId: 'ApprovalId',
        velocifyId: 'velocifyId',
        inventoryId: 'InventoryId',
        approvalDate: 'ApprovalDate',
        expirationDate: 'VoucherExpDate',
        isbuyprogramExecRequired: 'IsBuyProgramExecRequired',
        // id: 'id', - Will not transform, but accessible via `.get('id')`
        // gapWaiver: 'gapWaiver', - Will not transform, but accessible via `.get('gapWaiver')`
        // buyProgram: 'buyProgram', - Will not transform, but accessible via `.get('buyProgram')`
        // monthlyPayment: 'monthlyPayment', - Will not transform, but accessible via `.get('monthlyPayment')`

        IsDemo: 'IsDemo',
        BuyPrograms: BuyProgramModel,
        VelocifyField: 'VelocifyField',
        VelocifyValue: 'VelocifyValue',
        MarketingConsent: 'MarketingConsent',
        PrivacyPolicyConsent: 'PrivacyPolicyConsent',
    }
    public defaults: any = {
        IsDemo: false,
        BuyPrograms: [],
        MarketingConsent: false,
        VelocifyField: 'VehicleID',
        PrivacyPolicyConsent: false,
    }
    constructor (args) {
        super(args)
        this.init(args, this);

        // Push Inventory ID to `VelocifyValue` //
        this.set('VelocifyValue', this.get('inventoryId', null));

        // Process Buy Program Payload //
        try {
            const buyPrograms = new BuyProgramModel(JSON.parse(this.get('buyProgram')));
            buyPrograms.values = buyPrograms.values.map((bp: BuyProgramModel, index: number) => {
                // This is possible for is classic cars 1 BP but no index //
                if (index == this.get('id') || this.get('id') === null) {
                    bp.set('IsSelected', true);
                    if (this.get('gapWaiver')) {
                        bp.set('IsGAPWaiverSelected', true);
                        bp.set('ApprovalDate', this.get('approvalDate'));
                        bp.set('ExpirationDate', this.get('expirationDate'));
                        bp.set('EcsType', this.get('ecsType'));
                    } else {
                        bp.set('GAPWaiverAmount', 0);
                        bp.set('AdvantageCoverageAmt', 0);
                        bp.set('PowertrainCoverageAmt', 0);
                        bp.set('IsGAPWaiverSelected', false);
                    }
                }
                return bp;
            })
            this.set('BuyPrograms', buyPrograms);
        } catch {
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auto-loans/models/update-offer.model.ts